import { jsonp, ajax } from '@ifeng/ui_base';
import { formatImage, formatUrl } from '@ifeng/public_method';

// apiUrl为webpack注入的全局变量
/* eslint-disable no-undef */
let apiBaseUrl = apiUrl;

/* eslint-enable no-undef */

if (/\.shank\.ifeng\.com/.test(window.location.hostname)) {
    apiBaseUrl = '/api';
}

const createJsonpCallbackName = (str, num) => {
    const md5 = require('md5');

    num = num ? num : 0;
    const jsonpCallbackName = `_${md5(`${str}_${num}`)}`;

    if (window[jsonpCallbackName]) {
        num++;
        createJsonpCallbackName(str, num);
    } else {
        return jsonpCallbackName;
    }
};

/* 公共 */

// 获取文章评论数
const getCommentCount = async url => {
    return await jsonp('//comment.ifeng.com/get.php', {
        data: {
            job: 4,
            format: 'js',
            callback: 'getAllComment1',
            docurl: url.join('|'),
        },
        jsonCallback: 'getAllComment1',
        cache: false,
    });
};

// 点击更多，获取信息流
// const getColumnInfo = async (id, time, size, columnId) => {
//     return await ajax(`/c/api/getColumnInfo/${id}/${time}/${size}/${columnId}`);
// };

// 点击更多，获取信息流
const getColumnInfo2 = async (id, time, size, columnId) => {
    return await jsonp(`${apiBaseUrl}/getColumnInfo3/${id}/${time}/${size}/${columnId}/getColumnInfoCallback`, {
        jsonpCallback: 'getColumnInfoCallback',
    });
};

// 点击更多，获取科技频道信息流
const getTechInfo = async (id, time, size, columnId) => {
    return await jsonp(`${apiBaseUrl}/getTechInfo/${id}/${time}/${size}/${columnId}/getTechInfoCallback`, {
        jsonpCallback: 'getTechInfoCallback',
    });
};

// 获取公益频道信息流
const getGongyiData = async (id, time, size, columnId) => {
    return await jsonp(`${apiBaseUrl}/getGongyiData/${id}/${time}/${size}/${columnId}/getGongyiDataCallback`, {
        jsonpCallback: 'getGongyiDataCallback',
    });
};

/**
 * 获取页面动态碎片数据
 * @param {Array} recommendDataIds 推荐位数据IDs
 * @param {String} searchPath searchPath
 * @param {Number} page 当前页数
 * @param {Number} pageSize 每页请求条数
 * @returns {Object} {dynamicList, pageInfo}
 */
const getDynamicData = async ({ recommendDataIds = [], searchPath = 0, page = 1, pageSize = 9 }) => {
    const recommendIds = recommendDataIds.join(',');

    const data = await jsonp(
        `${apiBaseUrl}/getDynamicData/${searchPath}/${recommendIds}/${page}/${pageSize}/getDynamicData`,
        {
            jsonpCallback: 'getDynamicData',
        },
    );

    return data.data;
};
/**
 * 获取排行榜数据
 */

const getCheZhanData = async () => {
    const data = await jsonp('//api.auto.ifeng.com/cms/api/getChezhan');

    if (data.data) {
        data.data = data.data.map(item => ({
            url: formatUrl(item.url),
            title: item.name,

            image: item.image,
        }));
    } else {
        data.data = [];
    }

    return data.data;
};

/**
 * 获取排行榜数据
 */

const getHotArticleRank = async () => {
    const data = await jsonp('/c/api/shanklist/getHotArticleRank/', {
        jsonpCallback: 'getHotArticleRank',
    });

    let resultData = [];

    if (data.data.toplist.rec) {
        resultData = data.data.toplist.rec.map(item => ({
            url: item.url,
            title: item.title,
        }));
    }

    return resultData;
};

/**
 * 获取大家都在看数据
 */
const getSeriesRankList = async () => {
    let dataurl = '//api.auto.ifeng.com/api/getSerialRefRecommen.do?callbackparam=asd123';

    let data = await jsonp(dataurl, {
        jsonpCallback: 'asd123',
        cache: false,
    });

    return data;
};
/**
 * 获取新车日历数据
 */
const getNewCarList = async (year, month) => {
    let data = await jsonp(`//api.auto.ifeng.com/cms/api/CarRili?year=${year}&month=${month}`, {
        jsonpCallback: 'getNewCarList',
        cache: false,
    });

    return data;
};

export {
    getCommentCount,
    getColumnInfo2,
    getDynamicData,
    getTechInfo,
    getGongyiData,
    getHotArticleRank,
    getSeriesRankList,
    getCheZhanData,
    getNewCarList,
};
